import $ from "jquery";
import "slick-carousel";

const inThePakketSlider = () => {
    const target = ".sp-in-het-pakket .card-wrapper-slider";
    const $target = $(target);

    const init = () => {
        $(document).ready(function () {
        if ($target.length) {
            exec();
        }
        });
    };

    const exec = () => {
        $target.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            dots: false,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 1025,
                    settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: false,
                    arrows: true,
                    dots: false,
                    },
                },
                {
                    breakpoint: 600,
                    settings: "unslick",
                },
            ],
        });
    };

    init();
};

try {
    inThePakketSlider();
} catch (error) {
    throw Error(error);
}
